import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import { useRegistrationDeadline } from "@/hooks/useRegistrationDeadline";
import { useOrganization } from "@/contexts/OrganizationContext";

const RegistrationDeadlineBanner = () => {
  const { data: deadlineData, isLoading } = useRegistrationDeadline();
  const { organization } = useOrganization();

  // Only show for flagship org
  if (!organization?.is_flagship) return null;
  
  // Don't show while loading or if no deadline set
  if (isLoading || !deadlineData) return null;
  
  // Hide if deadline has passed
  if (deadlineData.isExpired) return null;

  // Progressive urgency messaging
  const getMessage = () => {
    if (deadlineData.isLastDay) {
      return "Last day to register!";
    }
    if (deadlineData.daysRemaining <= 2) {
      return `Only ${deadlineData.daysRemaining} day${deadlineData.daysRemaining === 1 ? '' : 's'} left!`;
    }
    if (deadlineData.daysRemaining <= 7) {
      return `${deadlineData.daysRemaining} days left to register`;
    }
    return "Limited Capacity";
  };

  return (
    <div className="bg-gradient-to-r from-violet-600 to-purple-600 text-white px-4 py-2.5 text-center text-sm font-medium">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-2 flex-wrap">
        <Clock className="h-4 w-4 flex-shrink-0 hidden sm:block" />
        <span>{getMessage()} ·</span>
        <span>Registration closes {deadlineData.formattedDeadline}</span>
        <Link 
          to="/attendees#register-form" 
          className="underline underline-offset-2 font-semibold hover:no-underline ml-1"
        >
          Register Now →
        </Link>
      </div>
    </div>
  );
};

export default RegistrationDeadlineBanner;
